import React from "react";
import PropTypes from "prop-types";
import RadioButtons from "./RadioButtons";

function TypeOfReport({ children, values, name, register }) {
	const isMultipleChoice = values.length > 1;

	return isMultipleChoice ? (
		<React.Fragment>
			<h3>{children}</h3>
			<RadioButtons name={name} values={values} register={register} />
		</React.Fragment>
	) : (
			<React.Fragment>
				<h3>{values[0].label}</h3>
				<input type="hidden" name={name} value={values[0].value} ref={register} />
			</React.Fragment>
		);
}

TypeOfReport.propTypes = {
	children: PropTypes.string.isRequired,
	values: PropTypes.arrayOf(
		PropTypes.shape({ value: PropTypes.string, text: PropTypes.string })
	).isRequired,
	name: PropTypes.string.isRequired,
	register: PropTypes.func.isRequired
};

export default TypeOfReport;